import { render } from "./ParticipantDetail.vue?vue&type=template&id=0afc40e4&scoped=true&ts=true"
import script from "./ParticipantDetail.vue?vue&type=script&lang=ts"
export * from "./ParticipantDetail.vue?vue&type=script&lang=ts"

import "./ParticipantDetail.vue?vue&type=style&index=0&id=0afc40e4&lang=css"
import "./ParticipantDetail.vue?vue&type=style&index=1&id=0afc40e4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0afc40e4"]])

export default __exports__